export { WatchProjectHero } from './WatchProjectHero'
export { WatchProjectHeroNew } from './WatchProjectHeroNew'
export { WatchProjectHeroTest } from './WatchProjectHeroTest'
export type { BackgroundPosition } from './WatchProjectHero'
